export default __webpack_public_path__ + "static/media/react.7aa3e743.png";